import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewTeacherComp from "./Component/ViewTeacherComp"


const ViewTeacher =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewTeacherComp />
            
        </div>
        <Footer />
        </>
    )
}

export default ViewTeacher